"use client";

import { useAppDispatch, useEffect } from "@/utils/hooks/reactUseCustomHooks";
import { setCurrentPage } from "@/utils/redux/ads";
import { setProductAemData } from "@/utils/redux/productsListing/aemContentSlice";
import { setAemData } from "@/utils/redux/recipes/aemContentSlice";
import { setMessages, setHomepageBanner, setHomePageRecipeData } from "@/utils/redux/recipes/recipeSlice";
import { setMessages as setMealPlanMessages } from "@/utils/redux/mealPlan/mealPlanSlice";

export default function HomeDispatch({aemData}: any) {

    const dispatch = useAppDispatch();

     useEffect(() => {
    if (!aemData) return;

    const { serverRecipes,productFilters } = aemData;  
      dispatch(setMessages(serverRecipes?.successAndErrorMessages));
      dispatch(setAemData(serverRecipes?.aemData));
      dispatch(setProductAemData(productFilters));
      dispatch(setMealPlanMessages(serverRecipes?.successAndErrorMessages));
      dispatch(setCurrentPage("/"));
  }, []);
    return null;
}